import { render, staticRenderFns } from "./CarTypePopup.vue?vue&type=template&id=04e4721d&scoped=true&"
import script from "./CarTypePopup.vue?vue&type=script&lang=ts&"
export * from "./CarTypePopup.vue?vue&type=script&lang=ts&"
import style0 from "./CarTypePopup.vue?vue&type=style&index=0&id=04e4721d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e4721d",
  null
  
)

export default component.exports